<div [ngClass]="isCustomWidth ? 'custom-width' : ''" class="breadcrumbText">
  <ul class="page-breadcrumb breadcrumb">
    <li class="active custom-upper-margin pointer">
      <a style="color: #020202" routerLink="/dashboard"
        ><img src="./assets/icons/Home_icon.svg" class="home-spacing" /><span class="liTagText"
          >Home</span
        >
      </a>
      <i class="fa fa-angle-right fa-lg"></i>
    </li>
    <li
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
      (click)="routeToPage()"
      class="active custom-upper-margin pointer"
    >
      <span class="liTagText">{{ activatedPath }}</span>
      <i *ngIf="!!childActivatedPath" class="fa fa-angle-right fa-lg"></i>
    </li>
    <li
      routerLinkActive="active"
      *ngIf="!!childActivatedPath"
      [routerLinkActiveOptions]="{ exact: true }"
      class="active custom-upper-margin"
      (click)="routeToSettings()"
    >
      <span class="liTagText scenario-name projectNameElipsis" title="{{ childActivatedPath }}">{{
        truncateText(childActivatedPath, 4)
      }}</span>
      <i
        *ngIf="scenarioName && scenarioName != 'null' && isInProjects"
        class="fa fa-angle-right fa-lg"
      ></i>
    </li>
    <li
      routerLinkActive="active"
      *ngIf="scenarioName && scenarioName != 'null' && isInProjects"
      class="active custom-upper-margin"
      (click)="routeOfScenario()"
    >
      <span class="liTagText scenario-name">{{ scenarioName }}</span>
      <i *ngIf="projectNameIso && !!projectNameIso" class="fa fa-angle-right fa-lg"></i>
    </li>
    <li
      routerLinkActive="active"
      *ngIf="projectNameIso && !!projectNameIso"
      class="active custom-upper-margin projectISONameTxt"
    >
      <span class="scenario-name">{{ projectNameIso }}</span>
    </li>
  </ul>
</div>
